import { render, staticRenderFns } from "./SignOut.vue?vue&type=template&id=13580b42"
import script from "./SignOut.vue?vue&type=script&lang=ts"
export * from "./SignOut.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports